import { useQuery, QueryHookOptions } from '@apollo/client';

import { MEMBER_FIELD_SCHEMAS_BY_SECTIONS_QUERY } from '@frontend/app/queries';
import { MemberFieldSchemasBySectionsQuery } from '@frontend/app/queries/types/MemberFieldSchemasBySectionsQuery';

type IOptions = QueryHookOptions<MemberFieldSchemasBySectionsQuery, {}>;

export const useMemberFieldSchemasBySectionsQuery = (options: IOptions = {}) =>
  useQuery<MemberFieldSchemasBySectionsQuery, {}>(MEMBER_FIELD_SCHEMAS_BY_SECTIONS_QUERY, options);
